export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function getOtherBodyInPair(pair, body) {
  if (!pair || !body) return null;
  if (pair.bodyA && pair.bodyA.id === body.id) return pair.bodyB || null;
  if (pair.bodyB && pair.bodyB.id === body.id) return pair.bodyA || null;
  return null;
}

export function getBodyHalfHeight(body) {
  if (!body || !body.bounds) return 0;
  return Math.max(0, (body.bounds.max.y - body.bounds.min.y) / 2);
}

/**
 * Distance from the body centre to its left / right / top / bottom edge. Circles use the true
 * radius; ellipses read the live bounds, so a rotated creature is held where Matter rests it
 * (not at its long radius, which shoved standing ellipses off walls and floor).
 */
export function getFlaskBodyExtents(meta, fallbackRadius) {
  var body = meta && meta.body;
  var r = fallbackRadius != null ? fallbackRadius : Math.max(meta.radiusX || 0, meta.radiusY || 0, 4);
  var isCircle = Math.abs((meta.radiusX || 0) - (meta.radiusY || 0)) < 0.01;
  if (isCircle || !body || !body.bounds || !body.position
    || !isFinite(body.bounds.min.x) || !isFinite(body.bounds.max.x)) {
    return { left: r, right: r, top: r, bottom: r };
  }
  var x = body.position.x;
  var y = body.position.y;
  return {
    left: Math.max(1, x - body.bounds.min.x),
    right: Math.max(1, body.bounds.max.x - x),
    top: Math.max(1, y - body.bounds.min.y),
    bottom: Math.max(1, body.bounds.max.y - y),
  };
}

/** Lowest world-space Y on the body (handles rotated ellipse vertices). */
export function getFlaskBodyTopY(meta) {
  var body = meta && meta.body;
  if (!body) return 0;
  var top = Infinity;
  if (body.vertices && body.vertices.length) {
    for (var i = 0; i < body.vertices.length; i++) {
      var vy = body.vertices[i].y;
      if (vy < top) top = vy;
    }
  }
  if (isFinite(top)) return top;
  if (body.bounds && isFinite(body.bounds.min.y)) return body.bounds.min.y;
  var y = body.position.y;
  var radius = Math.max(meta.radiusX || 0, meta.radiusY || 0, 4);
  return y - radius;
}

/** Top/bottom Y — prefers live Matter bounds (critical for small tilted ellipses). */
export function getFlaskBodyVerticalExtents(meta) {
  var body = meta && meta.body;
  if (!body || !body.position) return { bodyTop: 0, bodyBottom: 0, halfH: 0 };
  var y = body.position.y;
  var top;
  var bottom;
  if (body.bounds
    && isFinite(body.bounds.min.y)
    && isFinite(body.bounds.max.y)
    && body.bounds.max.y > body.bounds.min.y) {
    top = body.bounds.min.y;
    bottom = body.bounds.max.y;
  } else {
    var halfH = getBodyHalfHeight(body);
    var radius = Math.max(meta.radiusX || 0, meta.radiusY || 0, 4);
    if (halfH < radius) halfH = radius;
    top = y - halfH;
    bottom = y + halfH;
  }
  var vertexTop = getFlaskBodyTopY(meta);
  if (vertexTop < top) top = vertexTop;
  return {
    bodyTop: top,
    bodyBottom: bottom,
    halfH: Math.max((bottom - top) / 2, 1),
  };
}
